<script lang="ts">
</script>

<header class="p-8 text-center bg-black w-screen web-only">
  <h1 class="text-7xl mb-4 hover:text-pink-600 text-white uppercase">Resume</h1>
  <button
    class="bg-purple-600 hover:bg-pink-600 p-2 text-white"
    on:click={() => window.print()}
    >Please click here to print, and once the print dialog box shows up, change
    the 'Destination' to be 'Save as PDF'.</button
  >
</header>
